<template lang="pug">
v-dialog(v-model="show" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(small color="blue" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-filter-variant
    v-card
        v-card-title Dashboard Filter
        v-card-text
            v-select(
                v-model="chartDateRange"
                :items="['1 Month','3 Months','6 Months','12 Months','Custom']"
                label="Date Range"
            )

            date-range-picker(
                v-if="chartDateRange === 'Custom'"
                v-model="dateRange"
                style="font-size: 15px; width: 100%; border-bottom: 1px solid #25252575;"
            )

            //- v-select(
            //-     v-model="userType"
            //-     :items="['Default','New Users','Existing Users']"
            //-     label="Users Type"
            //- )
        v-divider
        v-card-actions
            v-spacer
            v-btn(small color="red" text @click="show = false") Cancel
            v-btn(small color="primary" text @click="submit") Confirm
</template>

<script>
import moment from 'moment';

export default {
    name: 'FilterDialog',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    isUpdated: false,
                    dateRangeString: '1 Month',
                    dateRange: [moment().subtract(1, 'years').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                    userType: 0
                };
            }
        }
    },
    data() {
        const userTypes = ['Default','New Users','Existing Users'];
        return {
            show: false,
            chartDateRange: this.value.dateRangeString,
            userType: userTypes[this.value.userType],
            dateRange: this.value.dateRange,
        };
    },
    methods: {
        submit() {
            switch(this.chartDateRange) {
                case '1 Month':
                    this.dateRange = [moment().subtract(1, 'months').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')];
                    break;
                case '3 Months':
                    this.dateRange = [moment().subtract(3, 'months').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')];
                    break;
                case '6 Months':
                    this.dateRange = [moment().subtract(6, 'months').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')];
                    break;
                case '12 Months':
                    this.dateRange = [moment().subtract(12, 'months').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')];
                    break;
            }
            this.$emit('change', {
                isUpdated: true,
                dateRangeString: this.chartDateRange,
                userType: ['Default','New Users','Existing Users'].indexOf(this.userType),
                dateRange: this.dateRange
            });
            this.show = false;
        }
    }
}
</script>